/**
 * Header's top menu item
 */
import React, { useContext } from 'react';
import classnames from 'classnames';
import { AnalyticsContext, trackEvent } from 'latitude-analytics';
import MediaQuery from 'react-responsive';
import SvgInline from '@latitude/svg-inline';
import Section from '@latitude/section';
import { ANALYTICS } from '@latitude/core/utils/constants';
import { DESKTOP_CUTOFF_POINT, MOBILE_CUTOFF_POINT } from './BaseHeader.constant';
import './_top-menu-item.scss';

var TopMenuItem = function TopMenuItem(props) {
  var id = props.id,
      label = props.label,
      active = props.active,
      onClick = props.onClick,
      trackId = props.trackId,
      href = props.href,
      target = props.target;
  var className = props.className;
  var linkProps = {};

  var _useContext = useContext(AnalyticsContext),
      analytics = _useContext[0];

  if (href) {
    className = classnames('top-menu-item--link', className);
    linkProps.href = href;
    linkProps.target = target;
    /**
     * TODO: Awaiting confirmation from Matt E and tagging team on the below
     * - Need to confirm if domain will be one of ours
     * - Need to append gemid value for the link
     */

    linkProps.onClick = function (event) {
      trackEvent(analytics, {
        category: 'text-link',
        action: 'internal-link',
        label: event.currentTarget.innerText,
        location: ANALYTICS.LOCATION.HEADER
      });
    };
  } else {
    linkProps.onClick = function () {
      return onClick(props.id);
    };
  }

  return /*#__PURE__*/React.createElement("div", {
    key: id,
    className: classnames('top-menu-item', className, {
      'is-active': active
    })
  }, /*#__PURE__*/React.createElement("a", Object.assign({
    className: "top-menu-item__button link--no-style trackcustomanalytics" // onClick={handleClick}

  }, linkProps, {
    "data-trackid": trackId
  }), label && /*#__PURE__*/React.createElement("p", {
    className: "top-menu-item__label"
  }, label), /*#__PURE__*/React.createElement(SvgInline, {
    className: "top-menu-item__chevron",
    name: "chevron-right"
  })), /*#__PURE__*/React.createElement("div", {
    className: "top-menu-item__content"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: MOBILE_CUTOFF_POINT
  }, props.children), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: DESKTOP_CUTOFF_POINT
  }, /*#__PURE__*/React.createElement(Section, null, props.children))));
};

export default TopMenuItem;